import { useLoader } from '@react-three/fiber';
import * as THREE from 'three';
import { AssetFindOptions, get, find } from '../queries/assets';
import { AssetModel, ThreekitSource } from '../types';

export default class AssetModelLoader extends THREE.Loader {
  source: ThreekitSource; // this must be set to use this loader

  static attach(source: ThreekitSource) {
    return (l: AssetModelLoader) => {
      l.source = source;
    };
  }

  public load(
    id: string,
    onLoad?: (result: AssetModel) => void,
    onProgress?: Function,
    onError?: Function
  ) {
    const source = this.source;
    if (!source) {
      throw new Error('ThreekitSource not found for AssetModelLoader');
    }

    function err(str: string) {
      if (onError) onError(str);
      else console.error(str);
    }

    async function doLoad() {
      const asset = await get(source, id);
      if (!asset) {
        return err('Invalid Asset');
      }

      if (onLoad) onLoad(asset);
      else err('No onLoad callback');
    }
    doLoad();
  }
}
// }
